var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row d-flex justify-content-center"},[_c('div',{staticClass:"col-lg-10"},[_c('card',{staticClass:"card-calendar"},[_c('calendar')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }